import React, { useEffect, useRef, useState } from "react";
import Cookies from 'js-cookie';
var CryptoJS = require("crypto-js");

// function ReportBuilder() {
const ReportBuilder = ({func}) => {

    const [reportBulider, setReportBulider] = useState(false);
    // eslint-disable-next-line
    const [partnerSelected, setPartnerSelected] = useState(true);
    const [partner, setPartner] = useState('');

    const [metricsSelectAll, setMetricsSelectAll] = useState(false);
    const [metricsCount, setMetricsCount] = useState(0);

    const [dimensionsSelectAll, setDimensionsSelectAll] = useState(false);
    const [dimensionsCount, setDimensionsCount] = useState(0);

    const refReportBuilder = useRef(null);

    useEffect(() => {
        function handleClickOutsideReportBuilder(event) {
            if (refReportBuilder.current && !refReportBuilder.current.contains(event.target)) {
                setReportBulider(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutsideReportBuilder);

        if(JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).google_id.length > 0){
            // console.log('Checking if google is checked');
            // if (document.getElementById('google').checked) {
                setPartner('google');
                setMetricsCount(1);
                setDimensionsCount(6);
            // }
        }else if(JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).aniview_id.length > 0){
            // if (document.getElementById('aniview').checked) {
                setPartner('aniview');
                setMetricsCount(0);
                setDimensionsCount(0);
            // }
        }else if(JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).adkernel_id.length > 0){
            // console.log('Checking if adkenel is checked');
            // if (document.getElementById('adkernel').checked) {
                setPartner('adkernel');
                setMetricsCount(1);
                setDimensionsCount(5);
            // }
        }
    }, [refReportBuilder]);
    
    // Open Close Report Builder Drop Down
    const handleReportBuilder = () => {
        setReportBulider(!reportBulider);
    }

/////////////////////////////////////////////////////////// Partners //////////////////////////////////////////////////////

    // work when Click on Platform Checkbox
    const handlePlatform = (e) => {
        var platform = document.querySelectorAll('.platform');
        if(platform.length > 1) {
            setPartnerSelected(true);
            setPartner(e);
            setMetricsCount(0);
            setMetricsSelectAll(false);
            setDimensionsCount(0);
            setDimensionsSelectAll(false);
            document.getElementById('MetricsSelectAll').parentNode.classList.remove('active');
            document.getElementById('MetricsSelectAll').checked=false;
            document.getElementById('DimensionsSelectAll').parentNode.classList.remove('active');
            document.getElementById('DimensionsSelectAll').checked=false;
            
            for (var ip = 0; ip < platform.length; ip++) {
                platform[ip].checked = false;
                document.getElementById(platform[ip].id).parentNode.classList.remove('active');
            }
        }


        document.getElementById(e).checked = true;
        document.getElementById(e).parentNode.classList.add('active');
    }

/////////////////////////////////////////////////////////// Matrics //////////////////////////////////////////////////////
    // Metrics Logic
    let filledMatricsSet = [];

    // Function to check if two arrays are equal
    function arraysAreEqual(arr1, arr2) {
        if (arr1.length !== arr2.length) {
        return false;
        }
    
        for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
        }
    
        return true;
    }

    // check Matrics checkbox and manage Matrics Count
    const handleMatrixCount = (e) => {
        
        let minusDimensionsCount = 0;
        let adkernelMatricsSet = {
            "date": ["date","zone","site_domain","app_bundle","banner_size","video_size_ex","country"],
            "zone": ["zone","date","site_domain","app_bundle","banner_size","video_size_ex","country"],
            "site_domain": ["site_domain","date", "country","zone"],
            "app_bundle": ["app_bundle","date", "country","zone"],
            "banner_size": ["banner_size","date", "zone"],
            "country": ["country","date", "zone","app_bundle","site_domain"],
            "video_size_ex": ["video_size_ex","date", "zone"]
        };
        if(partner === 'adkernel') {

            if (document.getElementById(e).checked) {
                // document.getElementById(e).checked=true;
                document.getElementById(e).disabled = false;
                document.getElementById(e).parentNode.style.cursor = "pointer"
                document.getElementById(e).parentNode.classList.add('active');
                // setMetricsCount(metricsCount + 1);
                filledMatricsSet.push(adkernelMatricsSet[e]);
            } else {
                // document.getElementById(e).checked=false;
                document.getElementById(e).disabled = false;
                document.getElementById(e).parentNode.style.cursor = "pointer"
                document.getElementById(e).parentNode.classList.remove('active');
                // setMetricsCount(metricsCount - 1);

                // Use the filter method to create a new parent array without the specified child array
                filledMatricsSet = filledMatricsSet.filter(childArray => !arraysAreEqual(childArray, adkernelMatricsSet[e]));
            }
            
            // Find common values among all child arrays
            let commonValues;
            if(filledMatricsSet.length>0){
                commonValues = filledMatricsSet.reduce((accumulator, currentArray) => {
                    return accumulator.filter(value => currentArray.includes(value));
                });
            }

            var clearAllMetrics = document.querySelectorAll('.metrics');
            // setMetricsCount(0);
            
            if(filledMatricsSet.length>0){
            // if(commonValues.includes(e) && checkboxes>1){
                for (var icm = 0; icm < clearAllMetrics.length; icm++) {
                    if(clearAllMetrics[icm].id !== e) {
                        if(!commonValues.includes(clearAllMetrics[icm].id)){
                            clearAllMetrics[icm].checked = false;
                            document.getElementById(clearAllMetrics[icm].id).parentNode.classList.remove('active');

                            clearAllMetrics[icm].disabled = true;
                            clearAllMetrics[icm].parentNode.style.cursor = "not-allowed";
                        }
                    }
                }
            }else {
                for (var icm1 = 0; icm1 < clearAllMetrics.length; icm1++) {
                    if(clearAllMetrics[icm1].id !== e) {
                        clearAllMetrics[icm1].disabled = false;
                        clearAllMetrics[icm1].parentNode.style.cursor = "pointer";
                    }
                }
            }
            
            commonValues?.forEach((element) => {
                document.getElementById(element).disabled = false;
                document.getElementById(element).parentNode.style.cursor = "pointer";
            });

            
            if( (document.getElementById('video_size_ex').checked) || (document.getElementById('banner_size').checked) || (document.getElementById('country').checked) || (document.getElementById('site_domain').checked) || (document.getElementById('app_bundle').checked) ) {
                
                if(document.getElementById('rtb_pub_revenue').checked) {minusDimensionsCount=minusDimensionsCount+1;}
                if(document.getElementById('rtb_pub_ecpm').checked) {minusDimensionsCount=minusDimensionsCount+1;}

                document.getElementById('rtb_pub_revenue').checked = false;
                document.getElementById('rtb_pub_revenue').parentNode.classList.remove('active');
                document.getElementById('rtb_pub_revenue').disabled = true;
                document.getElementById('rtb_pub_revenue').parentNode.style.cursor = "not-allowed";

                document.getElementById('rtb_pub_ecpm').checked = false;
                document.getElementById('rtb_pub_ecpm').parentNode.classList.remove('active');
                document.getElementById('rtb_pub_ecpm').disabled = true;
                document.getElementById('rtb_pub_ecpm').parentNode.style.cursor = "not-allowed";

            }else {
                document.getElementById('rtb_pub_revenue').disabled = false;
                document.getElementById('rtb_pub_revenue').parentNode.style.cursor = "pointer";

                document.getElementById('rtb_pub_ecpm').disabled = false;
                document.getElementById('rtb_pub_ecpm').parentNode.style.cursor = "pointer";
            }

            let inputElements = [].slice.call(document.querySelectorAll('.metrics'));
            let checkedValue = inputElements.filter(chk => chk.checked).length;
            setMetricsCount(checkedValue);
            setDimensionsCount(dimensionsCount - minusDimensionsCount);
        }else {
            if (document.getElementById(e).checked) {
                document.getElementById(e).parentNode.classList.add('active');
                setMetricsCount(metricsCount + 1);
            } else {
                document.getElementById(e).parentNode.classList.remove('active');
                setMetricsCount(metricsCount - 1);
            }
        }
    }

    // Select all Metrics
    const handleMetricsSelectAll = () => {
        setMetricsSelectAll(!metricsSelectAll);
        var clearAllMetrics = document.querySelectorAll('.metrics');
        if (!metricsSelectAll) {
            document.getElementById('MetricsSelectAll').parentNode.classList.add('active');
            if(partner === 'adkernel') {
                for (var icmadk1 = 0; icmadk1 < clearAllMetrics.length; icmadk1++) {
                    clearAllMetrics[icmadk1].checked = false;
                    clearAllMetrics[icmadk1].disabled = false;
                    document.getElementById(clearAllMetrics[icmadk1].id).parentNode.classList.remove('active');
                    document.getElementById(clearAllMetrics[icmadk1].id).parentNode.style.cursor='pointer';
                }
                setMetricsCount(4);
                for (var icmadk = 0; icmadk < clearAllMetrics.length; icmadk++) {
                    if( ["date","zone","site_domain","country"].includes(clearAllMetrics[icmadk].id) ) {
                        clearAllMetrics[icmadk].checked = true;
                        document.getElementById(clearAllMetrics[icmadk].id).parentNode.classList.add('active');   
                    }
                }
            }else {
                setMetricsCount(clearAllMetrics.length);
                for (var icm = 0; icm < clearAllMetrics.length; icm++) {
                    clearAllMetrics[icm].checked = true;
                    document.getElementById(clearAllMetrics[icm].id).parentNode.classList.add('active');
                }
            }
        } else {
            document.getElementById('MetricsSelectAll').parentNode.classList.remove('active');
            setMetricsCount(0);
            for (var icn = 0; icn < clearAllMetrics.length; icn++) {
                clearAllMetrics[icn].checked = false;
                document.getElementById(clearAllMetrics[icn].id).parentNode.classList.remove('active');
            }
        }
    }

    // Clear all Metrics
    const handleMatrixClear = () => {
        setMetricsSelectAll(false);
        setMetricsCount(0);
        document.getElementById('MetricsSelectAll').parentNode.classList.remove('active');
        document.getElementById('MetricsSelectAll').checked = false;
        var clearAllMetrics = document.querySelectorAll('.metrics');
        for (var icn = 0; icn < clearAllMetrics.length; icn++) {
            clearAllMetrics[icn].checked = false;
            document.getElementById(clearAllMetrics[icn].id).parentNode.classList.remove('active');
        }
    }

    // Search in Matrics
    const handleMetrixSearch = (e) => {
        var value = e.toLowerCase().trim();
        let matrixLabels = document.querySelectorAll('.matrix-label');
        for (var ml = 0; ml < matrixLabels.length; ml++) {
            if (value) {
                if (matrixLabels[ml].textContent.toLowerCase().trim().indexOf(value) === -1) {
                    matrixLabels[ml].parentNode.style.display = 'none';
                } else {
                    matrixLabels[ml].parentNode.style.display = 'block';
                }
            } else {
                matrixLabels[ml].parentNode.style.display = 'block';
            }
        }
    }



/////////////////////////////////////////////////////////// Dimensions //////////////////////////////////////////////////////

    // check Dimensions checkbox and manage Dimensions Count
    const handleDimensionsCount = (e) => {
        if (document.getElementById(e).checked) {
            document.getElementById(e).parentNode.classList.add('active');
            setDimensionsCount(dimensionsCount + 1);
        } else {
            document.getElementById(e).parentNode.classList.remove('active');
            setDimensionsCount(dimensionsCount - 1);
        }
    }

    // Select All Dimensions
    const handleDimensionsSelectAll = () => {
        setDimensionsSelectAll(!dimensionsSelectAll);
        var clearAllDimensions = document.querySelectorAll('.dimensions');
        if (!dimensionsSelectAll) {
            document.getElementById('DimensionsSelectAll').parentNode.classList.add('active');
            if(partner === 'adkernel') {
                if( (document.getElementById('video_size_ex').checked) || (document.getElementById('banner_size').checked) ) {
                    setDimensionsCount(5);
                    for (var icmadk1 = 0; icmadk1 < clearAllDimensions.length; icmadk1++) {
                        if( !["rtb_pub_requests","rtb_pub_coverage","rtb_pub_coverage_rate","rtb_pub_win_rate"].includes(clearAllDimensions[icmadk1].id) ) {
                            clearAllDimensions[icmadk1].checked = true;
                            document.getElementById(clearAllDimensions[icmadk1].id).parentNode.classList.add('active');
                        }
                    }
                }else {
                    setDimensionsCount(clearAllDimensions.length);
                    for (var icmadk2 = 0; icmadk2 < clearAllDimensions.length; icmadk2++) {
                        clearAllDimensions[icmadk2].checked = true;
                        document.getElementById(clearAllDimensions[icmadk2].id).parentNode.classList.add('active');
                    }
                }
            }else {
                setDimensionsCount(clearAllDimensions.length);
                for (var icm = 0; icm < clearAllDimensions.length; icm++) {
                    clearAllDimensions[icm].checked = true;
                    document.getElementById(clearAllDimensions[icm].id).parentNode.classList.add('active');
                }
            }
        } else {
            document.getElementById('DimensionsSelectAll').parentNode.classList.remove('active');
            setDimensionsCount(0);
            for (var icn = 0; icn < clearAllDimensions.length; icn++) {
                clearAllDimensions[icn].checked = false;
                document.getElementById(clearAllDimensions[icn].id).parentNode.classList.remove('active');
            }
        }
    }

    // Clear All Dimensions
    const handleDimensionsClear = () => {
        setDimensionsSelectAll(false);
        setDimensionsCount(0);
        document.getElementById('DimensionsSelectAll').parentNode.classList.remove('active');
        document.getElementById('DimensionsSelectAll').checked = false;
        var clearAllDimensions = document.querySelectorAll('.dimensions');
        for (var icn = 0; icn < clearAllDimensions.length; icn++) {
            clearAllDimensions[icn].checked = false;
            document.getElementById(clearAllDimensions[icn].id).parentNode.classList.remove('active');
        }
    }

    // Search in Dimensions
    const handleDimensionsSearch = (e) => {
        var value = e.toLowerCase().trim();
        let matrixLabels = document.querySelectorAll('.dimensions-label');
        for (var ml = 0; ml < matrixLabels.length; ml++) {
            if (value) {
                if (matrixLabels[ml].textContent.toLowerCase().trim().indexOf(value) === -1) {
                    matrixLabels[ml].parentNode.style.display = 'none';
                } else {
                    matrixLabels[ml].parentNode.style.display = 'block';
                }
            } else {
                matrixLabels[ml].parentNode.style.display = 'block';
            }
        }
    }

    
    // Master Clear All
    const handleClearAll = () => {
        // setPartnerSelected(false);
        setMetricsSelectAll(false);
        setMetricsCount(0);
        setDimensionsSelectAll(false);
        setDimensionsCount(0);
        
        var clearAllPlatform = document.querySelectorAll('.platform');
        if(clearAllPlatform.length > 1) {
            for (var icp = 0; icp < clearAllPlatform.length; icp++) {
                clearAllPlatform[icp].checked = false;
                document.getElementById(clearAllPlatform[icp].id).parentNode.classList.remove('active');
            }
        }

        document.getElementById('MetricsSelectAll').checked = false;
        document.getElementById('DimensionsSelectAll').checked = false;
        var clearAllMetrics = document.querySelectorAll('.metrics');
        for (var icm = 0; icm < clearAllMetrics.length; icm++) {
            clearAllMetrics[icm].checked = false;
            document.getElementById(clearAllMetrics[icm].id).parentNode.classList.remove('active');
        }
        var clearAllDimensions = document.querySelectorAll('.dimensions');
        for (var icmd = 0; icmd < clearAllDimensions.length; icmd++) {
            clearAllDimensions[icmd].checked = false;
            document.getElementById(clearAllDimensions[icmd].id).parentNode.classList.remove('active');
        }
        document.getElementById('metrix-accordian').classList.add('collapsed');
        document.getElementById('collapseTwo').classList.remove('show');
        document.getElementById('dimensions-accordian').classList.add('collapsed');
        document.getElementById('collapseThree').classList.remove('show');
    }

    // Work on Apply Button
    const submitReportBuilder = () => {
        let reportPostData = [];
        let metrix = [];
        let dimensions = [];
        reportPostData['sdate'] = document.getElementById('hiddenDateRange').value.split(' - ')[0];
        reportPostData['edate'] = document.getElementById('hiddenDateRange').value.split(' - ')[1];
        reportPostData['email'] = JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).email;
        reportPostData['type'] = JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).user_type;
        if(JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).google_id.length > 0){
            if (document.getElementById('google').checked) {
                reportPostData['platform'] = 'google';
                reportPostData['pub_ids'] = document.getElementById('google').value.split(",");
            }
        }
        if(JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).aniview_id.length > 0){
            if (document.getElementById('aniview').checked) {
                reportPostData['platform'] = 'aniview';
                reportPostData['pub_ids'] = document.getElementById('aniview').value.split(",");
            }
        }
        if(JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).adkernel_id.length > 0){
            if (document.getElementById('adkernel').checked) {
                reportPostData['platform'] = 'adkernel';
                reportPostData['pub_ids'] = document.getElementById('adkernel').value.split(",");
            }
        }

        var metricsCheckboxes = document.querySelectorAll('.metrics');
        var n = 0;
        for (var icmx = 0; icmx < metricsCheckboxes.length; icmx++) {
            if (metricsCheckboxes[icmx].checked) {
                metrix[n] = metricsCheckboxes[icmx].value;
                n++;
            }
        }

        var dimensionsCheckboxes = document.querySelectorAll('.dimensions');
        var m = 0;
        for (var icdx = 0; icdx < dimensionsCheckboxes.length; icdx++) {
            if (dimensionsCheckboxes[icdx].checked) {
                dimensions[m] = dimensionsCheckboxes[icdx].value;
                m++;
            }
        }

        reportPostData['metrics'] = metrix;
        reportPostData['dimensions'] = dimensions;
        func({ "sdate": reportPostData.sdate, "edate": reportPostData.edate, "email": reportPostData.email, "type": reportPostData.type, "platform": reportPostData.platform, "pub_ids": reportPostData.pub_ids, "metrics": reportPostData.metrics, "dimensions": reportPostData.dimensions});
        setReportBulider(false);
    }

    return (
        <div className="position-relative btn_filter" ref={refReportBuilder}>
            <button id="reportBuilderBtn" className={(reportBulider) ? 'btn_outline active' : 'btn_outline'} onClick={handleReportBuilder} ref={refReportBuilder}>
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" width="16" height="16">
                    <path stroke="#1D8F83" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M3,2C2.5,2,2,2.5,2,3.1v0.6c0,0.4,0.2,0.9,0.5,1.2l3.2,3.4l0,0c0.6,0.6,1,1.5,1,2.4v3c0,0.2,0.2,0.3,0.4,0.2l1.8-1c0.3-0.2,0.5-0.4,0.5-0.8v-1.5c0-0.9,0.3-1.8,1-2.4l3.2-3.4C13.8,4.5,14,4.1,14,3.7V3.1C14,2.5,13.5,2,13,2H3z"/>
                </svg>
                Filter
            </button>

            <div className="dropdown_filter" style={{ display: (reportBulider) ? 'block' : 'none' }}>
                <div className="filter_content">
                    <div className="accordion" id="accordionExample">
                        
                        {/* Partners */}
                        <div className="accordion-item">
                            <div className="accordion-header" id="headingOne">
                                <button className="accordion-button py-2 px-0 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                    Platform
                                </button>
                            </div>
                            <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    <div id="platformChecklist">
                                        {
                                            (JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).google_id.length > 0)
                                            ?
                                            <div className="form-check">
                                                <label className="form-check-label active" htmlFor="google">
                                                    <input className="form-check-input platfrom_checkbox platform" type="checkbox" value={JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).google_id} id="google" onClick={(e) => handlePlatform(e.target.id)} />
                                                    Google
                                                </label>
                                            </div>
                                            :
                                            ""
                                        }
                                        {
                                            (JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).aniview_id.length > 0)
                                            ?
                                            <div className="form-check">
                                                <label className="form-check-label active" htmlFor="aniview">
                                                    <input className="form-check-input platfrom_checkbox platform" type="checkbox" value={JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).aniview_id} id="aniview" onClick={(e) => handlePlatform(e.target.id)} />
                                                    Aniview
                                                </label>
                                            </div>
                                            :
                                            ""
                                        }
                                        {
                                            (JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).adkernel_id.length > 0)
                                            ?
                                            <div className="form-check">
                                                <label className="form-check-label" htmlFor="adkernel">
                                                    <input className="form-check-input platfrom_checkbox platform" type="checkbox" value={JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).adkernel_id} id="adkernel" onClick={(e) => handlePlatform(e.target.id)} />
                                                    Adkernel
                                                </label>
                                            </div>
                                            :
                                            ""
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {/* Metrics */}
                        <div className="accordion-item">
                            <div className="position-relative">
                                <div className="accordion-header" id="headingTwo">
                                    <button className="accordion-button py-2 px-0 collapsed" type="button" data-bs-toggle="collapse" data-bs-target={(partnerSelected) ? '#collapseTwo' : ''} aria-expanded="false" aria-controls="collapseTwo" disabled={!partnerSelected} id="metrix-accordian">

                                        <span className="w_145px"> Metrics <span className="text-primary">{(metricsCount > 0) ? '(' + metricsCount + ')' : ''}</span></span>
                                    </button>
                                </div>
                                {(metricsCount > 0)
                                    ?
                                    <>
                                        <button type="button" className="clearBtn" onClick={handleMatrixClear}>Clear</button>
                                    </>
                                    :
                                    ''
                                }
                            </div>
                            <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    <div className="search_content mb_10px">
                                        <input type="text" className="w-100" placeholder="Search" id="matrixSearch" onKeyUp={(e) => handleMetrixSearch(e.target.value)} />

                                    </div>
                                    <div className="form-check">
                                        <label className="form-check-label" htmlFor="MetricsSelectAll">
                                            <input className={(metricsCount !== 0 && metricsCount < document.querySelectorAll('.metrics').length) ? 'form-check-input indeterminate_check' : 'form-check-input'} type="checkbox" value="" name="selectAll" id="MetricsSelectAll" onClick={handleMetricsSelectAll} />
                                            Select all
                                        </label>
                                    </div>
                                    <hr />
                                    <div id="matrixChecklist" className="list_scroll">
                                        {
                                            (partner === 'google')
                                            ?
                                            Object.entries({"dt": "Date", "ad_id":"Ad ID", "ad_name":"Ad Name", "adCode":"Ad Unit Code", "cNetCode":"Child Network Code"}).map(([k,v]) => (
                                                <div className="form-check" key={k}>
                                                    <label className="form-check-label matrix-label" htmlFor={k}>
                                                        <input className="form-check-input platfrom_checkbox metrics" type="checkbox" value={k} id={k} onClick={(e) => handleMatrixCount(e.target.id)} />
                                                        {v}
                                                    </label>
                                                </div>
                                            ))
                                            :
                                            ""
                                        }
                                        {
                                            (partner === 'aniview')
                                            ?
                                            Object.entries({}).map(([k,v]) => (
                                                <div className="form-check" key={k}>
                                                    <label className="form-check-label matrix-label" htmlFor={k}>
                                                        <input className="form-check-input platfrom_checkbox metrics" type="checkbox" value={k} id={k} onClick={(e) => handleMatrixCount(e.target.id)} />
                                                        {v}
                                                    </label>
                                                </div>
                                            ))
                                            :
                                            ""
                                        }
                                        {
                                            (partner === 'adkernel')
                                            ?
                                            Object.entries({"date": "Date", "zone": "Zone", "site_domain": "Site", "app_bundle": "Application", "banner_size": "Banner Size", "country": "Country", "video_size_ex": "Video Size"}).map(([k,v]) => (
                                                <div className="form-check" key={k}>
                                                    <label className="form-check-label matrix-label" htmlFor={k}>
                                                        <input className="form-check-input platfrom_checkbox metrics" type="checkbox" value={k} id={k} onClick={(e) => handleMatrixCount(e.target.id)} />
                                                        {v}
                                                    </label>
                                                </div>
                                            ))
                                            :
                                            ""
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {/* Dimensions */}
                        <div className="accordion-item">
                            <div className="position-relative">
                                <div className="accordion-header" id="headingThree">
                                    <button className="accordion-button py-2 px-0 collapsed" type="button" data-bs-toggle="collapse" data-bs-target={(partnerSelected) ? '#collapseThree' : ''} aria-expanded="false" aria-controls="collapseThree" disabled={!partnerSelected} id="dimensions-accordian">
                                        <span className="w_145px"> Dimensions <span className="text-primary">{(dimensionsCount > 0) ? '(' + dimensionsCount + ')' : ''}</span></span>
                                    </button>
                                </div>
                                {(dimensionsCount > 0)
                                    ?
                                    <>
                                        <button type="button" className="clearBtn" onClick={handleDimensionsClear}>Clear</button>
                                    </>
                                    :
                                    ''
                                }
                            </div>
                            <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    <div className="search_content mb_10px">
                                        <input type="text" className="w-100" placeholder="Search" id="dimensionsSearch" onKeyUp={(e) => handleDimensionsSearch(e.target.value)} />

                                    </div>
                                    <div className="form-check">
                                        <label className="form-check-label" htmlFor="DimensionsSelectAll">
                                            <input className={(dimensionsCount !== 0 && dimensionsCount < document.querySelectorAll('.dimensions').length) ? 'form-check-input indeterminate_check' : 'form-check-input'} type="checkbox" value="" name="selectAll" id="DimensionsSelectAll" onClick={handleDimensionsSelectAll} />
                                            Select all
                                        </label>
                                    </div>
                                    <hr />
                                    <div id="dimensionsChecklist" className="list_scroll">
                                        {
                                            (partner === 'google')
                                            ?
                                            Object.entries({"adx_aveImp":"Ad Impressions", "adx_clicks":"Clicks", "adx_ctr":"CTR", "adx_rev":"Revenue", "adx_ecpm":"Avg eCPM", "adx_req":"Total Requests", "adx_matchRate":"Match %", "adx_reqECPM":"Total Requests eCPM", "adx_matchECPM":"Match Request eCPM", "adx_avvImp":"Viewable Impressions", "adx_avvImpRate":"Viewable Impressions %", "adx_res":"Responses Served"}).map(([k,v]) => (
                                                <div className="form-check" key={k}>
                                                    <label className="form-check-label dimensions-label" htmlFor={k}>
                                                        <input className="form-check-input platfrom_checkbox dimensions" type="checkbox" value={k} id={k} onClick={(e) => handleDimensionsCount(e.target.id)} />
                                                        {v}
                                                    </label>
                                                </div>
                                            ))
                                            :
                                            ""
                                        }
                                        {
                                            (partner === 'aniview')
                                            ?
                                            Object.entries({}).map(([k,v]) => (
                                                <div className="form-check" key={k}>
                                                    <label className="form-check-label dimensions-label" htmlFor={k}>
                                                        <input className="form-check-input platfrom_checkbox dimensions" type="checkbox" value={k} id={k} onClick={(e) => handleDimensionsCount(e.target.id)} />
                                                        {v}
                                                    </label>
                                                </div>
                                            ))
                                            :
                                            ""
                                        }
                                        {
                                            (partner === 'adkernel')
                                            ?
                                            Object.entries({"rtb_pub_requests":"Requests", "rtb_pub_coverage":"Responses", "rtb_pub_coverage_rate":"Coverage %", "rtb_pub_impressions":"Impressions", "rtb_pub_win_rate":"Impression Win %", "rtb_pub_net_clicks":"Clicks", "rtb_pub_ctr":"Gross CTR", "rtb_pub_revenue":"Revenue", "rtb_pub_ecpm":"eCPM"}).map(([k,v]) => (
                                                <div className="form-check" key={k}>
                                                    <label className="form-check-label dimensions-label" htmlFor={k}>
                                                        <input className="form-check-input platfrom_checkbox dimensions" type="checkbox" value={k} id={k} onClick={(e) => handleDimensionsCount(e.target.id)} />
                                                        {v}
                                                    </label>
                                                </div>
                                            ))
                                            :
                                            ""
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div className="filter_bottom d-flex justify-content-between">
                    <div>
                        {
                            (partnerSelected > 0)
                            ?
                            <button type="button" className="clearAllBtn" onClick={handleClearAll}>Clear all</button>
                            :
                            ""
                        }
                    </div>
                    <div>
                        {
                            (partnerSelected && metricsCount > 0 && dimensionsCount > 0)
                            ?
                            <button type="button" className="applyBtn" onClick={submitReportBuilder}>Apply</button>
                            :
                            <button type="button" className="applyBtn position-relative" disabled>Apply <span className="tooltip_content"> 
                            <img src="/assets/media/icons/info_circle.svg" className="me-2" alt="Warning Icon" />
                            Please select at least one metric and one dimension to proceed</span></button>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ReportBuilder;